import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { markPageJsExecuted } from "@faire/web/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { ActionName } from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";

const PAGE_JS_EXECUTED_MARK = markPageJsExecuted();

const SignUpUPLTActionNames: Partial<Record<Step, ActionName>> = {
  [Step.PERSONAL_INFO]: "page-sign-up-personal-info",
  [Step.BUSINESS_TYPE]: "page-sign-up-business-type",
  [Step.STORE_INFO]: "page-sign-up-store-info",
  [Step.OPENING_YEAR]: "page-sign-up-opening-year",
  [Step.RESELLER_CERT]: "page-sign-up-reseller-cert",
  [Step.SELECT_NET_TERMS]: "page-sign-up-select-net-terms",
  [Step.OWF_UPSELL]: "page-sign-up-owf-upsell",
  [Step.OWF_APPLICATION]: "page-sign-up-owf-application",
  [Step.ANNUAL_SALES]: "page-sign-up-annual-sales",
};

const getActionName = (
  step: keyof typeof SignUpUPLTActionNames,
  options?: {
    isFD?: boolean;
  }
): ActionName => {
  const stepName = SignUpUPLTActionNames[step] as ActionName;
  const signUpOrigin = options?.isFD ? "-fd" : "";

  if (step === Step.PERSONAL_INFO) {
    return `${stepName}${signUpOrigin}` as ActionName;
  }
  return stepName;
};

export const useSignUpUPLT = (props: {
  step: keyof typeof SignUpUPLTActionNames;
  isLoading?: boolean;
  ignoreImages?: boolean;
  disableUPLT?: boolean;
  numComponents?: number;
  options?: {
    isFD?: boolean;
  };
}) => {
  const { step, isLoading, ignoreImages, disableUPLT, options, numComponents } =
    props;
  const actionName = getActionName(step, options);
  return useUserPerceivedLoadTimingWithKey({
    name: actionName,
    pageLoadKey: actionName,
    numComponents: numComponents ?? 0,
    ignoreImages: ignoreImages ?? true,
    isPageLoading: isLoading ?? false,
    pageJsExecutedMark: PAGE_JS_EXECUTED_MARK,
    enableTrackPerformanceBreakdown: "internal-tracking",
    enabled: !disableUPLT,
  });
};
